import React from 'react';
import { Stack, Typography } from '@mui/material';
import { ManagementFocus } from '@root/api';
import { useTranslation } from '@root/app/shared/hooks/useTranslation';
import { focusNameKey } from '@root/app/shared/utils/managementFocus.utils';
import HfFocusIcon from './HfFocusIcon';

interface HfFocusValueProps {
    focus: ManagementFocus;
}

/* A chosen focus shown inline: small icon and name (select value or read-only text). */
const HfFocusValue: React.FC<HfFocusValueProps> = ({ focus }) => {
    const { t } = useTranslation();
    return (
        <Stack direction='row' spacing={1} alignItems='center'>
            <HfFocusIcon focus={focus} size={22} />
            <Typography variant='body3' component='span'>{t(focusNameKey(focus))}</Typography>
        </Stack>
    );
};

export default HfFocusValue;
